export const enum StatusEnum {
  Sent = "sent", //Message received by WhatsApp server. -- One checkmark
  Delivered = "delivered", //Message delivered to the recipient. -- Two checkmarks
  Read = "read", //Message read by recipient. -- Two blue checkmarks
  Failed = "failed", //Message failed to send. -- Red error triangle
  Deleted = "deleted", //Message deleted by the user. -- Message is replaced in WhatsApp mobile with the note "This message was deleted".
  Queued = "queued", //Tuvis status - Message saved inside the DB
  WaitToSession = "wait_to_session", //Tuvis status - message wait to open session with the customer
  ReSent = "re_sent", // Tuvis status - message has been failed but resent successfully
}

export type ContactsObject = Array<{
  addresses: Array<{ city?: string; country?: string; country_code?: string; state?: string; street?: string; zip?: string; type?: string }>;
  birthday?: string;
  emails: Array<{ email?: string; type?: string }>;
  name: { first_name?: string; last_name?: string; formatted_name: string };
  org: { company?: string; department?: string; title?: string };
  phones: Array<{ phone: string; wa_id?: string; type?: string }>;
  urls: Array<{ url?: string; type?: string }>;
}>;
